export function getWavenumbers(numPixels, coeffs, excitation) {
  if (!numPixels || !coeffs || !excitation) { return [] }
  let pixels = [...Array(numPixels).keys()];
  let wavelengths = pixels.map(pixel => coeffs.reduce((prev, curr, i) => prev + (curr * Math.pow(pixel, i))));
  let wavenumbers = wavelengths.map(wavelength => Math.round(((1e7 / excitation) - (1e7 / wavelength)) * 100) / 100);
  if (wavenumbers[0] > 225) {
    wavenumbers[0] = 225;
  }
  return wavenumbers;
}
